<rk-button
  [variant]="'secondary'"
  [fullWidth]="true"
  [icon]="'plus'"
  [text]="'add-a-stream.button' | translate"
  (buttonClick)="addNewStream()"
></rk-button>
